import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, NavbarBrand, Nav, NavItem, Collapse, NavbarToggler } from 'reactstrap';
import '../../App.scss';
import MonashLogo from '../../assets/images/MonashLogo.png';
import StudentFutures from '../../assets/images/SF-SiteName.png';
import EngineeringDashboard from '../../assets/images/EngineeringDashboard.png';

function bannerImage(location: string) {
    if (location.includes('certificate') || location.includes('reflections')) {
        return (
            <div className='sfImg'>
                <div className='my-3 container'>
                    <img src={MonashLogo} alt='Monash Logo' />
                    <a href='https://unihub.monash.edu/s/student-futures'>
                        <img src={StudentFutures} alt='Student Futures' />
                    </a>
                </div>
            </div>
        );
    }
    if (location.includes('engineering')) {
        return (
            <div className='engImg'>
                <div className='my-3 container'>
                    <img src={MonashLogo} alt='Monash Logo' />
                    <a href='https://unihub.monash.edu/s/engineering-cpd'>
                        <img src={EngineeringDashboard} alt='Engineering Dashboard' />
                    </a>
                </div>
            </div>);
    }
    return (<> </>);
}
const FrontNav = ({ location }: { location: string }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const url = window.location.href;
    return (
        <div className='header'>
            {url.includes('staging') || url.includes('localhost')
                ? <Navbar color='light' light expand='md'>
                    <NavbarBrand href='/'>Monash Reporting Tool</NavbarBrand>
                    <NavbarToggler onClick={toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className='mr-auto' navbar>
                            <NavItem>
                                <Link to='/reflections' className='nav-link'>Reflections Report</Link>
                            </NavItem>
                            <NavItem>
                                <Link to='/certificate' className='nav-link'>Monash Certificate</Link>
                            </NavItem>
                            <NavItem>
                                <Link to='/engineering' className='nav-link'>Engineering CPD</Link>
                            </NavItem>
                            <NavItem>
                                <Link to='/mastersengineering' className='nav-link'>Masters Engineering CPD</Link>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
                : <></>}
            {bannerImage(location)}
        </div>
    );
};

export default FrontNav;
